import moment from 'moment';

/**
 * A function if the default humanize from moment is not enough.
 * @param duration
 */
export function customHumanizeDuration(duration: moment.Duration) {
  const daysDiff = duration.get('day');
  const hourDiff = duration.get('hour');
  const minuteDiff = duration.get('minute');
  if (daysDiff >= 1) {
    return daysDiff + ' ' + (daysDiff == 1 ? 'day' : 'days');
  }
  if (hourDiff >= 1) {
    return hourDiff + ' ' + (hourDiff == 1 ? 'hour' : 'hours');
  }
  if (minuteDiff >= 1) {
    return minuteDiff + ' ' + (minuteDiff == 1 ? 'minute' : 'minutes');
  }

  return 'less than 1 minute';
}
